export const CategoriesEndpoints = {
    picker: () => '/categories/picker',
};
